<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="isLoading")
    .students-list(v-else)
        .students-list__header
            | {{ $i18n.t('olympiads.olympiads_studentList_registeredParticipants') }}
        .fields.students-list__fields(v-if="user.type !== 'student'")
            .fields__element.fields__element--large
                label.fields__label.fields__label--small {{ $i18n.tc('olympiads.olympiads_olympiadForm_schools', 0) }}
                cs-multiselect(
                    :options="olympiadSchools",
                    v-model="searchParams.school",
                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                    :multiple="false",
                    :allowEmpty="true",
                    label="name",
                    trackBy="id",
                    :maxHeight="160"
                )
            .fields__element.fields__element--large
                label.fields__label.fields__label--small {{ $i18n.tc('olympiads.olympiads_olympiadForm_grades', 0) }}
                cs-multiselect(
                    :options="olympiadGrades",
                    v-model="searchParams.grade",
                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                    :multiple="false",
                    :allowEmpty="true",
                    label="name",
                    trackBy="id",
                    :disabled="!searchParams.school",
                    :maxHeight="160",
                    :loading="areGradesLoading"
                )
            .fields__element.fields__element--large
                label.fields__label.fields__label--small {{ $i18n.t('fields.fields_search') }}
                cs-search-input(
                    :placeholder="$i18n.t('fields.list_studentPlaceholder')",
                    v-model="searchParams.studentName"
                )
            .fields__element.fields__element--fluid
                cs-button(
                    color="blue",
                    pattern="primary-outline",
                    html-tag="a"
                    href="javascript://"
                    @click="resetResults",
                    narrow
                )
                    | {{ $i18n.t('fields.fields_dropParameters') }}
        .students-list__levels
            level-list(
                v-for="level in olympiad.levels"
                :students="level.registeredUsers",
                :searchParams="searchParams",
                :level="level"
                :levels="olympiad.levels"
                :key="'level' + level.id"
                @openChangeLevelModal="openChangeLevelModal"
            )
        cs-modal(v-if="showChangeLevelModal", @close="closeChangeLevelModal")
            div(slot="header") {{ $i18n.t('olympiads.olympiads_registerPage_chooseATopic') }}
            .modal__levels
                .level__checkbox(
                    v-for="level in olympiad.levels"
                    @click="checkedLevel = level.id"
                )
                    cs-checkbox(
                        :checked="checkedLevel === level.id"
                        @click="checkedLevel = level.id",
                        :key="'checkbox' + level.id"
                    )
                        | {{ level.theme }}
                        | &nbsp;
                        | {{ '(' + level.startTime + '-'  + level.endTime + ')' }}
            div.modal__button(slot="footer")
                cs-button(@click="saveNewUserLevel(checkedLevel)") {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
</template>

<script>
    /*eslint-disable*/
    import LevelList from './LevelList.vue';
    import OlympiadApi from '../../../api/olympiad';
    import SchoolApi from '../../../api/school';
    import LevelApi from '../../../api/olympiads/level';
    import GradeApi from '../../../api/grade';
    import {mapState} from 'vuex';

    export default {
        props: {
            id: [Number, String]
        },
        data() {
            return {
                olympiad: null,
                isLoading: true,
                searchParams: {
                    school: null,
                    grade: null,
                    studentName: "",
                },
                schoolGrades: null,
                allSchools: null,
                levels: null,
                showChangeLevelModal: false,
                checkedLevel: null,
                selectedStudent: null,
                areGradesLoading: false,
            }
        },
        mounted () {
            this.fetchData();
        },
        watch: {
            'searchParams.school': {
                handler(val) {
                    this.searchParams.grade = null;
                    if (val && val.id) {
                        this.getSchoolGrades(val.id);
                    }
                },
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            olympiadGrades() {
                return this.schoolGrades ? this.schoolGrades : [];
            },
            olympiadSchools() {
                if (this.olympiad.schools && this.olympiad.schools.length) {
                    return this.olympiad.schools;
                } else {
                    return this.allSchools ? this.allSchools : [];
                }
            },
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                OlympiadApi.show(this.id)
                .then(olympiad => {
                    this.olympiad = olympiad;
                    if (!this.olympiad.schools.length) {
                        this.getAllSchools();
                    } else {
                        this.isLoading = false;
                    }
                })
                .catch(err => {
                    err = (err.response && err.response.data) ? err.response.data : err;
                    if (err && (err.status_code === 403 || err.status_code === 404)) {
                        this.$toasted.error(this.i18n.t(`errors.${err.message}`));
                    }
                    this.isLoading = false;
                });
            },
            getSchoolGrades (schoolId) {
                this.areGradesLoading = true;
                GradeApi.list( {
                    schoolId: schoolId,
                    all: true
                }).then(data => {
                    this.schoolGrades = data.grades;
                }).catch(() => {
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                }).finally(() => {
                    this.areGradesLoading = false;
                });
            },
            getAllSchools () {
                if (this.allSchools) {
                    this.isLoading=false;
                    return;
                }
                let schools = [];
                SchoolApi.list({
                    all: true,
                    status: 'active'
                }).then(data => {
                    schools = data.schools;
                    this.allSchools = schools ? schools : [];
                    this.isLoading = false;
                }).catch(() => {
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    this.isLoading = false;
                });
            },
            openChangeLevelModal (level, student) {
                this.showChangeLevelModal = true;
                this.checkedLevel = level.id;
                this.selectedStudent = student;
            },
            closeChangeLevelModal () {
                this.checkedLevel = null;
                this.selectedStudent = null;
                this.showChangeLevelModal = false;
            },
            saveNewUserLevel (levelId) {
                let form = {
                    userId: this.selectedStudent.id
                }
                LevelApi.update(levelId, form)
                .then(() => {
                    this.$emit('close');
                })
                .then(() => this.fetchData())
                .catch(() => {
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    this.isLoading = false;
                });
                this.checkedLevel = null;
                this.selectedStudent = null;
                this.showChangeLevelModal = false;
            },
            resetResults () {
                this.searchParams.school = null;
                this.searchParams.grade = null;
                this.searchParams.studentName = "";
            }
        },
        components: {
            LevelList,
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/fields/fields.scss";

    .students-list {
        margin: 0 auto;
        padding: 30px;
        box-sizing: border-box;
        background-color: $x-color-white;
        max-width: 840px;
        border-radius: $border-radius-12;
    }

    .students-list__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 30px;
    }

    .students-list__fields {
        margin-bottom: 30px;
    }

    .modal__levels {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -10px;
    }

    .level__checkbox {
        padding: 10px;
        box-sizing: border-box;
        font-size: 16px;
    }

    .modal__button {
        margin: 0 auto;
    }
</style>
